import { createFileRoute } from "@tanstack/react-router";
import type { FermentationDashboardId } from "@brewbase/db/types";
import { DashboardEditor } from "@/features/fermentation-dashboard/dashboard-editor";
export const Route = createFileRoute("/fermentations/dashboards/$dashboardId")({
  component: DashboardPage,
});
function DashboardPage() {
  const { dashboardId } = Route.useParams();
  return (
    <DashboardEditor
      dashboardId={Number(dashboardId) as FermentationDashboardId}
    />
  );
}
